import { render, staticRenderFns } from "./InvoiceDeleteAlert.vue?vue&type=template&id=94288ad8"
import script from "./InvoiceDeleteAlert.vue?vue&type=script&lang=js"
export * from "./InvoiceDeleteAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports